import { render, staticRenderFns } from "./Lgx479736705511849984.vue?vue&type=template&id=4570149a&scoped=true&"
import script from "./Lgx479736705511849984.vue?vue&type=script&lang=js&"
export * from "./Lgx479736705511849984.vue?vue&type=script&lang=js&"
import style0 from "./Lgx479736705511849984.vue?vue&type=style&index=0&id=4570149a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4570149a",
  null
  
)

export default component.exports